import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useContext, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AddEditBeneficiaryModal from '../../../../components/AddNewBeneficiary/AddEditBeneficiaryModal';
import Blockquote from '../../../../components/Blockquote';
import Button from '../../../../components/Button';
import CircledIcon from '../../../../components/CircledIcon';
import Support from '../../../../components/Support';
import SupportMobile from '../../../../components/Support/SupportMobile';
import Switch from '../../../../components/Switch';
import UserCard from '../../../../components/UserCards/UserCard';
import UserDefaultCard from '../../../../components/UserCards/UserDefaultCard';
import UserCardWithInput from '../../../../components/UserCardWithInput';
import useModal from '../../../../hooks/useModal';
import { BeneficiariesStore } from '../../../../providers/beneficiaries';
import { Profile } from '../../../../types';

export type selectBeneficiaryProps = {
  data: any;
  collectStepData: (data: any) => void;
  title?: string;
  subtitle?: string;
  quote?: string;
};

const SelectBeneficiary = ({
  data,
  collectStepData,
  title = 'Select Beneficiary',
  subtitle = 'You have a chosen an option that may result in payments being made to someone other than your beneficiary. Please provide the information below so that correct payments may be made at the time of your death.',
  quote = "If you don't make an election and you die the remaining payment will be made first to your designated beneficiary and if your beneficiary is dead then to your Estate.",
}: selectBeneficiaryProps) => {
  const [showBeneficiaries, setShowBeneficiary] = useState(false);
  const [showContingent, setShowContingent] = useState(false);
  const [isSwitchedChecked, setSwitchChecked] = useState(false);
  const [showModal, handleShow, handleClose] = useModal();
  const { profiles, add } = useContext(BeneficiariesStore);

  const handleSubmit = (data: any) => {
    if (data.beneficiaryType === 'person') {
      data.name = `${data.firstName} ${data.lastName}`;
    } else {
      data.firstName = data.entityName;
      data.name = data.entityName;
      data.relationship = data.beneficiaryType;
    }

    add(data);
  };

  const handleShowBeneficiaries = () => {
    setShowBeneficiary(!showBeneficiaries);
  };

  const handleShowContingents = () => {
    setShowContingent(!showContingent);
  };

  const handleEvenDistribution = () => {
    const c = [...data.contingents];

    c.map((element) => {
      element.contingentValueInput = Math.floor(100 / c.length);

      return collectStepData({
        ...data,
        contingents: (data.contingents = c),
      });
    });

    setSwitchChecked(!isSwitchedChecked);
  };

  const handleRemoveBeneficiary = () => {
    collectStepData({
      ...data,
      beneficiary: {
        ...data.beneficiary,
        id: undefined,
        name: undefined,
        relationship: undefined,
        image: undefined,
        beneficiaryValueInput: undefined,
      },
    });
  };

  const handleAddBeneficiaries = (beneficiary: Profile) => {
    if (data.beneficiary.id === beneficiary.id) {
      handleRemoveBeneficiary();

      return;
    }

    collectStepData({
      ...data,
      beneficiary: {
        ...data.beneficiary,
        id: beneficiary.id,
        name: beneficiary.name,
        relationship: beneficiary.relationship,
        image: beneficiary.image,
      },
    });
    setShowBeneficiary(!showBeneficiaries);
  };

  const handleBeneficiaryNumberInput = (value: number | undefined | null) => {
    collectStepData({
      ...data,
      beneficiary: {
        ...data.beneficiary,
        beneficiaryValueInput: value,
      },
    });
  };

  const handleRemoveContingent = (contingent: Profile) => {
    const c = [...data.contingents.filter((x: any) => x !== contingent)];

    data.contingents.length > 1 && isSwitchedChecked
      ? c.map((element) => {
          element.contingentValueInput = Math.floor(100 / c.length);

          return collectStepData({
            ...data,
            contingents: (data.contingents = c),
          });
        })
      : collectStepData({
          ...data,
          contingents: (data.contingents = c),
        });

    c.length <= 1
      ? setSwitchChecked((prev) => (prev = false))
      : setSwitchChecked((prev) => prev);
  };

  const handleAddContingets = (contingent: Profile) => {
    if (data.contingents.some((x: Profile) => x.id === contingent.id)) {
      handleRemoveContingent(
        data.contingents.find((x: Profile) => x.id === contingent.id)
      );

      return;
    }

    collectStepData({
      ...data,
      contingents: [
        ...data.contingents,
        {
          id: contingent.id,
          name: contingent.name,
          relationship: contingent.relationship,
          image: contingent.image,
          contingentValueInput: undefined,
        },
      ],
    });
  };

  const handleContingentNumberInput = (
    idx: number,
    value: number | null | undefined
  ) => {
    const c = [...data.contingents];
    c[idx].contingentValueInput = value;

    collectStepData({
      ...data,
      contingents: (data.contingents[idx] = c),
    });

    setSwitchChecked((prev) => (prev = false));
  };

  return (
    <Container className={'cnd-custom-container mt-12'}>
      <Row>
        <Col className="p-0 col-12 col-lg-8">
          <Row className={'mb-7'}>
            <Col className={'col-12 mb-7'}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <h5 className={' text-sm-20-lg-24'}>Select Beneficiary</h5>
                <div className={' text-sm-20-lg-24 d-lg-none'}>
                  <SupportMobile>
                    <div className="p-0 mt-4">
                      <span className="fw-bold text-caption">
                        Retirement Case Administrator
                      </span>
                      <div className="mt-4">
                        <CircledIcon
                          icon={light('user-headset')}
                          label="Jessica Wright"
                        />
                      </div>
                      <div className="mt-4">
                        <CircledIcon
                          icon={light('phone')}
                          label="1-800-888-8888 x 1234"
                        />
                      </div>
                    </div>
                  </SupportMobile>
                </div>
              </div>
            </Col>
            <Col
              className={'col-12 text-fs-6 text-ligther-grey fw-light lh-xxs'}
            >
              <span>{subtitle}</span>
            </Col>
          </Row>
          <Row>
            <Col>
              <Blockquote>
                <Container className={'px-0 d-flex flex-column'}>
                  <span className={'text-catpion fw-bold'}>Did You Know?</span>
                  <span className={'text-caption fw-light'}>{quote}</span>
                </Container>
              </Blockquote>
            </Col>
          </Row>
        </Col>
        <div className="d-none d-lg-flex justify-content-lg-end align-items-lg-start col-lg-4">
          <section>
            <Support>
              <div className="p-0 mt-4">
                <span className="fw-bold text-caption">
                  Retirement Case Administrator
                </span>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('user-headset')}
                    label="Jessica Wright"
                  />
                </div>
                <div className="mt-4">
                  <CircledIcon
                    icon={light('phone')}
                    label="1-800-888-8888 x 1234"
                  />
                </div>
              </div>
            </Support>
          </section>
        </div>
      </Row>
      <Row className={'mt-10'}>
        <Col>
          <span className={'text-sm-20-lg-24'}>Primary</span>
        </Col>
        <Col className={'text-end'}>
          <Button
            onMouseDown={handleShowBeneficiaries}
            variant={'primary'}
            leftIcon={light('user-plus')}
            size={'sm'}
          >
            Choose
          </Button>
        </Col>
        <Col className={'col-12'}>
          <span
            className={
              'd-block text-fs-6 text-ligther-grey fw-light border-bottom-light-gray-lg pb-3'
            }
          >
            Select who you'd like to receive the payment
          </span>
        </Col>
      </Row>
      <Container>
        {showBeneficiaries && (
          <Row className={'border-bottom-light-gray-lg py-7'}>
            {profiles.map((profile: Profile, idx: number) => {
              return (
                <Col key={idx} className={'col-12 col-lg-2 mb-5 mb-lg-0'}>
                  <UserCard
                    onClick={() => handleAddBeneficiaries(profile)}
                    item={profile}
                    selected={data.beneficiary.id === profile.id}
                  />
                </Col>
              );
            })}
            <Col>
              <UserDefaultCard onClick={handleShow} />
            </Col>
          </Row>
        )}
      </Container>

      <Container className={'py-7 mb-10'}>
        {!Object.values(data.beneficiary).some((x) => x !== undefined) ? (
          <Row className={'d-flex align-items-center'}>
            <Col className={'col-3 col-lg-2'}>
              <img
                src={`${
                  process.env.PUBLIC_URL
                }/${'no-beneficiary-selected.png'}`}
                alt="no-beneficiary"
              />
            </Col>
            <Col className={'col-6'}>
              <span className={'d-block text-fs-6 text-ligther-grey fw-light'}>
                No Beneficiary Selected
              </span>
            </Col>
          </Row>
        ) : (
          <UserCardWithInput
            item={data.beneficiary}
            onClick={handleRemoveBeneficiary}
            onChange={handleBeneficiaryNumberInput}
            numberInputValue={data.beneficiary.beneficiaryValueInput}
          />
        )}
      </Container>

      <Row className={'mt-10'}>
        <Col>
          <span className={'text-sm-20-lg-24'}>Contingent</span>
        </Col>
        <Col className={'text-end'}>
          <Button
            onMouseDown={handleShowContingents}
            variant={'primary'}
            leftIcon={light('user-plus')}
            size={'sm'}
          >
            Choose
          </Button>
        </Col>
        <Col className={'col-12'}>
          <span
            className={
              'd-block text-fs-6 text-ligther-grey fw-light border-bottom-light-gray-lg pb-3'
            }
          >
            Select who you'd like to receive the payment
          </span>
        </Col>
      </Row>

      <Container>
        {showContingent && (
          <Row className={'border-bottom-light-gray-lg py-7'}>
            {profiles.map((profile: Profile, idx: number) => {
              return (
                <Col key={idx} className={'col-12 col-lg-2 mb-5 mb-lg-0'}>
                  <UserCard
                    onClick={() => handleAddContingets(profile)}
                    item={profile}
                    selected={data.contingents.some(
                      (x: Profile) => x.id === profile.id
                    )}
                  />
                </Col>
              );
            })}

            <Col>
              <UserDefaultCard onClick={handleShow} />
            </Col>
          </Row>
        )}
      </Container>

      <Container className={'py-7'}>
        {data.contingents.length > 1 ? (
          <Row className={'mb-7'}>
            <Col>
              <Switch
                onClick={handleEvenDistribution}
                label={'Evenly distribute'}
                checked={isSwitchedChecked}
              />
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {data.contingents.length === 0 ? (
          <Row className={'d-flex align-items-center'}>
            <Col className={'col-3 col-lg-2'}>
              <img
                src={`${
                  process.env.PUBLIC_URL
                }/${'no-beneficiary-selected.png'}`}
                alt="no-beneficiary"
              />
            </Col>
            <Col className={'col-6'}>
              <span className={'d-block text-fs-6 text-ligther-grey fw-light'}>
                No Beneficiary Selected
              </span>
            </Col>
          </Row>
        ) : (
          <Row>
            {data.contingents.map((contingent: any, idx: number) => {
              return (
                <Col key={idx} className={'col-12 col-lg-5 mb-7'}>
                  {
                    <UserCardWithInput
                      item={contingent}
                      onClick={() => handleRemoveContingent(contingent)}
                      onChange={(value: number | null | undefined) =>
                        handleContingentNumberInput(idx, value)
                      }
                      numberInputValue={
                        data.contingents[idx].contingentValueInput
                      }
                    />
                  }
                </Col>
              );
            })}
          </Row>
        )}
      </Container>

      <AddEditBeneficiaryModal
        title="Add New Beneficiary"
        showModal={showModal}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
      />
    </Container>
  );
};

export default SelectBeneficiary;
